export const CLASS_NAMES = {
  statusTag: "mb-2 md:mb-0 md:mr-6",
};

export const SKELETON_PROPS = {
  width: 60,
  height: 20,
  wrapperClassName: "mr-6",
};
